<div class="col-lg-12">
  <full-calendar 
  [options]="calendarOptions"
  
  ></full-calendar>
</div>